export enum TranslationEntity {
  lead = 'lead',
  task = 'task',
  activity = 'activity',
  quickFilter = 'quick_filter',
  filter = 'filter',
  list = 'list',
  automation = 'automation',
  advancedSearch = 'advanced_search',
  smartView = 'smart_view',
}

export const translations = {
  [TranslationEntity.lead]: {
    displayName: 'lead',
  },
  [TranslationEntity.task]: {
    displayName: 'task',
  },
  [TranslationEntity.activity]: {
    displayName: 'activity',
  },
  [TranslationEntity.quickFilter]: {
    displayName: 'quick filter',
  },
  [TranslationEntity.filter]: {
    displayName: 'filter',
  },
  [TranslationEntity.list]: {
    displayName: 'list',
  },
  [TranslationEntity.advancedSearch]: {
    displayName: 'advanced search',
  },
  [TranslationEntity.automation]: {
    displayName: 'automation',
  },
  [TranslationEntity.smartView]: {
    displayName: 'smart view',
  },
};
